import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { ObSessionServiceInterface, ObSessionStateType } from '@central-products/interface-obsession-service';
import { SessionManagerStateType } from '@central-products/interface-session-manager';
export var ObSessionService = /*#__PURE__*/function (_ObSessionServiceInte) {
  _inherits(ObSessionService, _ObSessionServiceInte);

  var _super = _createSuper(ObSessionService);

  function ObSessionService(config, dependencies) {
    var _this;

    _classCallCheck(this, ObSessionService);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", ObSessionStateType.SESSION_UNKNOWN);

    _defineProperty(_assertThisInitialized(_this), "onStateChangedCallback", void 0);

    _defineProperty(_assertThisInitialized(_this), "abortController", new AbortController());

    _defineProperty(_assertThisInitialized(_this), "loginAwaiters", []);

    _defineProperty(_assertThisInitialized(_this), "processSessionManagerState", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var state;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = _ref.state;

                if (state === SessionManagerStateType.LOGGED_IN) {
                  _this.processLoggedInState();
                }

                if (state === SessionManagerStateType.NOT_LOGGED_IN) {
                  _this.processNotLoggedInState();
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setState", function (state) {
      if (_this.state === state) {
        return;
      }

      _this.state = state;

      if (state === ObSessionStateType.SESSION_EXISTS) {
        _this.resolveLoginAwaiters();
      }

      if (_this.onStateChangedCallback) {
        _this.onStateChangedCallback({
          state: state
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSessionSyncIdentifier", function () {
      var _window$localStorage$, _window$localStorage, _window$localStorage$2;

      return (_window$localStorage$ = (_window$localStorage = window.localStorage) === null || _window$localStorage === void 0 ? void 0 : (_window$localStorage$2 = _window$localStorage.getItem) === null || _window$localStorage$2 === void 0 ? void 0 : _window$localStorage$2.call(_window$localStorage, ObSessionService.SESSION_SYNC_IDENTIFIER)) !== null && _window$localStorage$ !== void 0 ? _window$localStorage$ : null;
    });

    _defineProperty(_assertThisInitialized(_this), "hasSessionSyncIdentifier", function () {
      var _window$localStorage2, _window$localStorage3;

      return ((_window$localStorage2 = window.localStorage) === null || _window$localStorage2 === void 0 ? void 0 : (_window$localStorage3 = _window$localStorage2.getItem) === null || _window$localStorage3 === void 0 ? void 0 : _window$localStorage3.call(_window$localStorage2, ObSessionService.SESSION_SYNC_IDENTIFIER)) != null;
    });

    _defineProperty(_assertThisInitialized(_this), "setSessionSyncIdentifier", function (sessionId) {
      var _window$localStorage4, _window$localStorage5;

      (_window$localStorage4 = window.localStorage) === null || _window$localStorage4 === void 0 ? void 0 : (_window$localStorage5 = _window$localStorage4.setItem) === null || _window$localStorage5 === void 0 ? void 0 : _window$localStorage5.call(_window$localStorage4, ObSessionService.SESSION_SYNC_IDENTIFIER, sessionId);
    });

    _defineProperty(_assertThisInitialized(_this), "clearSessionSyncIdentifier", function () {
      var _window$localStorage6, _window$localStorage7;

      (_window$localStorage6 = window.localStorage) === null || _window$localStorage6 === void 0 ? void 0 : (_window$localStorage7 = _window$localStorage6.removeItem) === null || _window$localStorage7 === void 0 ? void 0 : _window$localStorage7.call(_window$localStorage6, ObSessionService.SESSION_SYNC_IDENTIFIER);
    });

    _this.config = _Object$assign({
      shouldFollowLogout: false
    }, config);
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(ObSessionService, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var sessionManagerState;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.dependencies['session-manager'].getState();

              case 2:
                sessionManagerState = _context2.sent;
                this.dependencies['session-manager'].onStateChanged(this.processSessionManagerState);
                this.processSessionManagerState(sessionManagerState);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", {
                  state: this.state
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.onStateChangedCallback = callback;
    }
  }, {
    key: "awaitLoggedIn",
    value: function awaitLoggedIn() {
      var _this2 = this;

      if (this.state === ObSessionStateType.SESSION_EXISTS) {
        return _Promise.resolve({});
      }

      return new _Promise(function (resolve) {
        return _this2.loginAwaiters.push(resolve);
      });
    }
  }, {
    key: "resolveLoginAwaiters",
    value: function resolveLoginAwaiters() {
      var waiter; // tslint:disable-next-line no-conditional-assignment

      while (waiter = this.loginAwaiters.pop()) {
        waiter({});
      }
    }
  }, {
    key: "processLoggedInState",
    value: function () {
      var _processLoggedInState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _yield$this$dependenc, sessionId, previousState;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.state !== ObSessionStateType.NO_SESSION && this.state !== ObSessionStateType.SESSION_UNKNOWN)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                if (!this.config.enableSessionManagerProxyMode) {
                  _context4.next = 5;
                  break;
                }

                this.setState(ObSessionStateType.SESSION_EXISTS);
                return _context4.abrupt("return");

              case 5:
                _context4.next = 7;
                return this.dependencies['session-manager'].getSessionIdentifier();

              case 7:
                _yield$this$dependenc = _context4.sent;
                sessionId = _yield$this$dependenc.sessionId;
                _context4.next = 11;
                return this.hasValidSession(sessionId);

              case 11:
                if (!_context4.sent) {
                  _context4.next = 15;
                  break;
                }

                this.setSessionSyncIdentifier(sessionId);
                this.setState(ObSessionStateType.SESSION_EXISTS);
                return _context4.abrupt("return");

              case 15:
                previousState = this.state;
                this.setState(ObSessionStateType.SESSION_REQUESTED);
                _context4.prev = 17;
                _context4.next = 20;
                return this.initSession();

              case 20:
                this.setSessionSyncIdentifier(sessionId);
                this.setState(ObSessionStateType.SESSION_EXISTS);
                _context4.next = 27;
                break;

              case 24:
                _context4.prev = 24;
                _context4.t0 = _context4["catch"](17);
                this.setState(previousState);

              case 27:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[17, 24]]);
      }));

      function processLoggedInState() {
        return _processLoggedInState.apply(this, arguments);
      }

      return processLoggedInState;
    }()
  }, {
    key: "processNotLoggedInState",
    value: function () {
      var _processNotLoggedInState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var previousState;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.state === ObSessionStateType.NO_SESSION)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                if (!this.config.enableSessionManagerProxyMode) {
                  _context5.next = 5;
                  break;
                }

                this.setState(ObSessionStateType.NO_SESSION);
                return _context5.abrupt("return");

              case 5:
                if (!(this.state === ObSessionStateType.SESSION_UNKNOWN)) {
                  _context5.next = 9;
                  break;
                }

                this.clearSessionSyncIdentifier();
                this.setState(ObSessionStateType.NO_SESSION);
                return _context5.abrupt("return");

              case 9:
                if (this.state === ObSessionStateType.SESSION_REQUESTED) {
                  this.abortController.abort();
                }

                previousState = this.state;
                _context5.prev = 11;
                _context5.next = 14;
                return this.destroySession();

              case 14:
                this.clearSessionSyncIdentifier();
                this.setState(ObSessionStateType.NO_SESSION);
                _context5.next = 21;
                break;

              case 18:
                _context5.prev = 18;
                _context5.t0 = _context5["catch"](11);
                this.setState(previousState);

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[11, 18]]);
      }));

      function processNotLoggedInState() {
        return _processNotLoggedInState.apply(this, arguments);
      }

      return processNotLoggedInState;
    }()
  }, {
    key: "initSession",
    value: function () {
      var _initSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.fetch("".concat(this.config.obSessionServiceUrl, "?action=GoCasLogin&target=").concat(encodeURIComponent("".concat(this.config.casUrl, "/imAlive"))), {
                  credentials: 'include',
                  signal: this.abortController.signal,
                  mode: 'no-cors'
                });

              case 3:
                _context6.next = 11;
                break;

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6["catch"](0);
                _context6.next = 9;
                return this.hasEstabilishedSession();

              case 9:
                if (_context6.sent) {
                  _context6.next = 11;
                  break;
                }

                throw _context6.t0;

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 5]]);
      }));

      function initSession() {
        return _initSession.apply(this, arguments);
      }

      return initSession;
    }()
  }, {
    key: "destroySession",
    value: function () {
      var _destroySession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.fetch("".concat(this.config.obSessionServiceUrl, "?action=DoLogout"), {
                  credentials: 'include',
                  redirect: this.config.shouldFollowLogout ? 'follow' : 'manual',
                  mode: 'cors'
                });

              case 3:
                _context7.next = 11;
                break;

              case 5:
                _context7.prev = 5;
                _context7.t0 = _context7["catch"](0);
                _context7.next = 9;
                return this.hasEstabilishedSession();

              case 9:
                if (!_context7.sent) {
                  _context7.next = 11;
                  break;
                }

                throw _context7.t0;

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 5]]);
      }));

      function destroySession() {
        return _destroySession.apply(this, arguments);
      }

      return destroySession;
    }()
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(url, params) {
        var _yield$fetch, status;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return fetch(url, params);

              case 2:
                _yield$fetch = _context8.sent;
                status = _yield$fetch.status;

                if (!(status >= 400)) {
                  _context8.next = 6;
                  break;
                }

                throw new Error("Failed to fetch ".concat(url, ". Status: ").concat(status));

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x4, _x5) {
        return _ref3.apply(this, arguments);
      };
    }())
  }, {
    key: "hasValidSession",
    value: function () {
      var _hasValidSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(sessionId) {
        var shouldValidateSession;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                shouldValidateSession = !this.hasSessionSyncIdentifier() || sessionId != null && this.getSessionSyncIdentifier() === sessionId;

                if (!shouldValidateSession) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return", this.hasEstabilishedSession());

              case 3:
                return _context9.abrupt("return", false);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function hasValidSession(_x6) {
        return _hasValidSession.apply(this, arguments);
      }

      return hasValidSession;
    }()
    /**
     * Open bet session is managed by calling CAS & open bet in a chain of redirects.
     * Login: browser -> OB (start login & clear cookies) -> CAS (attach serviceTicket to OB login url)
     * -> OB (actual login, setting cookies) -> cas/imAlive (doesn't bring any value, validates only cas session, looks like workaround)
     * Logout: browser -> OB (remove cookies & session) -> we should not follow the rest redirects
     * during this chain CUST_SSL_COOKIE is being set/removed.
     * There are 2 known issues may happen during this chain.
     * - redirect to cas/imAlive or any other failed due to CORS issue
     * - redirects ends up in the infinite loop.
     * In both cases OB session will be still successfully created
     * We also don't want to call GoCasLogin action in case OB session already valid (browser refresh)
     * There is an OpenBet endpoint dedicated to check current cust_ssl_cookie
     * It will respond only with a HTTP status:
     * 200: Session is open and valid
     * 401: No session could be found or session has expired
     * 403: Session is not valid
     * 500: An error occurred when validating session
     */

  }, {
    key: "hasEstabilishedSession",
    value: function () {
      var _hasEstabilishedSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return fetch("".concat(this.config.obSessionServiceUrl, "?action=CheckCustSession"), {
                  credentials: 'include'
                });

              case 3:
                response = _context10.sent;
                return _context10.abrupt("return", response.ok);

              case 7:
                _context10.prev = 7;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", false);

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 7]]);
      }));

      function hasEstabilishedSession() {
        return _hasEstabilishedSession.apply(this, arguments);
      }

      return hasEstabilishedSession;
    }()
  }]);

  return ObSessionService;
}(ObSessionServiceInterface);

_defineProperty(ObSessionService, "SESSION_SYNC_IDENTIFIER", 'OB_SESS_SYNC_KEY');
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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